// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mp","cardInnerHeading":"mq","toggleWrapperClass":"mr","changeProfile":"ms mr","textWrapperClass":"mt","toggleTextClass":"mu"};